import { AttemptScanStatus } from './enums';

/** The attempt-scans bucket's `file_size_limit`. */
export const MAX_ATTEMPT_SCAN_MEGABYTES = 50;
export const MAX_ATTEMPT_SCAN_BYTES = MAX_ATTEMPT_SCAN_MEGABYTES * 1024 * 1024;

/** The most files one upload sends, so a batch cannot outlast its signed URLs. */
export const MAX_ATTEMPT_SCAN_UPLOADS = 50;

/** The longest file name a scan records. */
export const ATTEMPT_SCAN_ORIGINAL_FILENAME_MAX_LENGTH = 512;

/** The longest reason a failed scan records. */
export const ATTEMPT_SCAN_STATUS_DETAIL_MAX_LENGTH = 2048;

/** A scan in either status has no reader left to write to it or its sheets. */
export const FINISHED_ATTEMPT_SCAN_STATUSES: readonly AttemptScanStatus[] = [
  AttemptScanStatus.Read,
  AttemptScanStatus.Failed,
];

/** How many scans or sheets one list returns when it names no number, and at most. */
export const ATTEMPT_LIST_DEFAULT_LIMIT = 200;
export const ATTEMPT_LIST_MAX_LIMIT = 1000;
